import { EnhancedDropDownRHF, IEnhancedDropDownRHF, LabelPosition } from "@websential/cosmic-v20";

import { FieldLayout } from "./FieldLayout";
import { GridSize } from "@mui/material";
import React from "react";

interface LayoutWithLabel {
  /**
   * The label content.
   */
  label: React.ReactNode;
  /**
   * If true, the '*' sign is displayed as required.
   */
  required?: boolean;
  /**
   * Set the position of label on the top or left of the input
   */
  labelPosition?: LabelPosition;
  /**
   * Defines the number of grids the label is going to use.  
   */
  labelColumns?: GridSize;
  /**
    * Defines the number of grids the field is going to use. 
    */
  fieldColumns?: GridSize;
}
export interface IEnhancedDropDownRHFWithVerifyLabel
  extends IEnhancedDropDownRHF,
    LayoutWithLabel {}

/**
 * React Hook Form Drop Down component.
 */
export const EnhancedDropDownRHFWithVerifyLabel: React.FC<IEnhancedDropDownRHFWithVerifyLabel> =
  ({
    label,
    required,
    labelPosition = LabelPosition.Top,
    labelColumns = 4,
    fieldColumns = 8,
    selectName,
    selectedItem,
    showEmpty,
    isDisabled = false,
    isHide = false,
    isSearchable,
    items,
    testId,
    onSelectionChangeHandler,
  }) => {
    return (
      <FieldLayout
        label={label}
        isRequired={required}
        labelPosition={labelPosition}
        labelColumns={labelColumns}
        fieldColumns={fieldColumns}
        fieldTopPadding={1.1}
        testId={testId}
      >
        <EnhancedDropDownRHF
          items={items}
          selectedItem={selectedItem}
          showEmpty={showEmpty}
          testId={testId}
          selectName={selectName}
          isDisabled={isDisabled}
          isHide={isHide}
          isSearchable={isSearchable}
          onSelectionChangeHandler={onSelectionChangeHandler}
        />
      </FieldLayout>
    );
  };
